<template>
    <div>
      <h3 id="company_name">{{ company_name }}</h3>
      <p class="eligibility_label">
        Tell us..
      </p>
      <Input
        :inputField="inputs.requestedAmount"
        inputName="How much funding do you need?"
        inputType="currency"
        :range="[5000, 1000000]"
        :icons="{ left: 'fa-dollar-sign' }"
      />
      <List
        :inputField="inputs.product"
        :options=productOptions
        inputName="What product are you interested in?"
        inputId="product"
        :fullWidthOption="false"
      />
      <Input
        :inputField="inputs.use_of_funds"
        inputName="How are you going to use your funds?"
        inputType="string"
      />
      <Checkbox :inputField="inputs.smsConsent" inputName="SMS Consent" inputType="required">
        I agree to the
        <a href="/application-agreement/" target="_blank">Cardiff Application Agreement</a> and
        <a href="/e-sign-consent/" target="_blank">E-Sign Consent Agreement</a>.
      </Checkbox>
      <div class="buttons is-right" @click="handleBlur">
        <a class="button is-link padded-button next-button continue-button" @click="next">Continue</a>
      </div>
    </div>
  </template>
  
  <script>
  import Vue from "vue";
  import CONSTANTS from "@/tools/translations.js";
  import Input from "@/components/shared/Input";
  import Dropdown from "@/components/shared/Dropdown";
  import Checkbox from "@/components/shared/Checkbox";
  import ApplyPage from "@/components/shared/ApplyPage";
  import List from "@/components/shared/List";
  import MyUtils from "@/utils/MyUtils";
  import $ from "jquery";
  
  export default {
    name: "RenewalApplyForm",
    components: {
      Input,
      // Dropdown,
      Checkbox,
      List
    },
    mixins: [ApplyPage],
    props: {
      amt: String,
      lang: String,
    },
    created: function () {
      console.log('created renewal apply form')
      this.language = "en";
      if (this.$route.params.language) {
        this.language = this.$route.params.language;
      }
      var tags = [];
      var language = this.language;
      $.each(CONSTANTS, function (key, value) {
        var translation = value[language];
        tags[key] = value[language];
      });
  
      this.tags = tags;
      //console.log(tags);
      // this.GET_STARTED_HEADING = CONSTANTS.GET_STARTED_HEADING[Vue.prototype.$language]
      
    },
    mounted : function(){
      console.log('renewal apply form, mounted:')
      console.log('mounted renewal apply form')
      let stored_company_name = MyUtils.getWithExpiry("company_name");
      if(stored_company_name){
        this.company_name = stored_company_name;
      }
      console.log('stored company name:', stored_company_name);
      $('.choice').trigger('click');
      $('#app-column-renewal .choice p').css('font-size','0.5rem');
    },
    data() {
      return {
        obj: "business",
        inputs: {
          requestedAmount: Input.model(),
          utm_device_type: this.getDeviceType(),
          utm_browser: this.getBrowserName(),
          utm_OS: this.getOperatingSystem(),
          product: Input.model(),
          use_of_funds : Input.model(),
          smsConsent: Input.model(),
        },
        productOptions: [
          "Working Capital",
          "Equipment Finance",
        ],
  
        tags: [],
  
        show_address_fields: true,
        selected_address: false,
        company_name : "Tell us about your need"
      };
    },
    methods: {
      handleBlur: function () {
        console.log("focus out");
      },
      // toggleAddressFields: function () {
      //   this.show_address_fields = !this.show_address_fields;
      // },
      getOperatingSystem: function () {
        let userAgent = navigator.userAgent || window.navigator.userAgent;
        let macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"];
        let windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"];
        let iosPlatforms = ["iPhone", "iPad", "iPod"];
  
        let os = null;
  
        macosPlatforms.forEach(function (platform, index) {
          if (userAgent.search(platform) !== -1) {
            os = platform;
          }
        });
  
        iosPlatforms.forEach(function (platform, index) {
          if (userAgent.search(platform) !== -1) {
            os = platform;
          }
        });
  
        windowsPlatforms.forEach(function (platform, index) {
          if (userAgent.search(platform) !== -1) {
            os = platform;
          }
        });
        if (/Android/.test(userAgent)) {
          os = "Android";
        } else if (!os && /Linux/.test(userAgent)) {
          os = "Linux";
        } else if (!os) {
          os = "Other";
        }
        return os;
      },
      getDeviceType: () => {
        const ua = navigator.userAgent;
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
          return "tablet";
        }
        if (
          /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
            ua
          )
        ) {
          return "mobile";
        }
        return "desktop";
      },
      getBrowserName: function () {
        let userAgent = navigator.userAgent;
        let browserName;
  
        if (userAgent.match(/chrome|chromium|crios/i)) {
          browserName = "Chrome";
        } else if (userAgent.match(/firefox|fxios/i)) {
          browserName = "Firefox";
        } else if (userAgent.match(/safari/i)) {
          browserName = "Safari";
        } else if (userAgent.match(/opr\//i)) {
          browserName = "Opera";
        } else if (userAgent.match(/edg/i)) {
          browserName = "Edge";
        } else {
          browserName = "Unknown browser";
        }
  
        return browserName;
      },
    },

    watch: {
      inputs: {
        deep: true,
        handler(newValue, oldvalue) {
        },
      },
    },
  };
  </script>
  
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#company_name{
  color: #000;
  text-align: center;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.eligibility_label{
  color: #000;
  text-align: center;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 25px; /* 125% */
}
#app-column-renewal .label{
  margin-bottom: 16px;
}
#app-column-renewal .choice{
  border: none!important;
  font-size: 0.5rem!important;
  margin:0px !important;
  padding-top: 0px;
}
#app-column-renewal .selected{
  background-color: white;
}

@media (max-width: 47.999em) {
  #company_name{
    text-align: left;
  }
  .eligibility_label{
    text-align: left;
  }
  #app-column-renewal{
    padding-left: 0;
    padding-right: 0;
  }
}
</style>